import React from 'react';
import { PrintIcon } from '@patternfly/react-icons';

export const icon = <PrintIcon />;
export const header = 'Printers';
export const description = 'Printers print a file from the computer';
export const documentation = {
  url: 'https://example.com',
};
export const action = { title: 'action-title', url: 'action-url' };

export const props = {
  icon,
  header,
  description,
  documentation,
};
